var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgUnvertraeglichkeiten = function SvgUnvertraeglichkeiten(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 30,
    viewBox: "0 0 29 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Unvertr\\xC3\\xA4glichkeiten"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16.8769 12.6171C17.0124 12.1831 17.0826 11.7314 17.0854 11.2767C17.0854 8.56607 14.4045 6.36182 14.4045 6.36182C14.4045 6.36182 10.8432 8.71143 11.589 12.1846",
    stroke: "currentColor",
    strokeWidth: 1.23,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M14.4039 20.6402C14.4039 20.6402 10.5149 20.9429 8.30345 18.7338C6.09205 16.5248 6.39707 12.6334 6.39707 12.6334C6.68268 12.6157 6.96901 12.6125 7.25494 12.6239",
    stroke: "currentColor",
    strokeWidth: 1.23,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M18.9597 19.5548C23.7876 17.9702 22.415 12.6311 22.415 12.6311C22.415 12.6311 18.974 11.6338 16.877 12.6168",
    stroke: "currentColor",
    strokeWidth: 1.23,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M14.4043 19.8467V22.7444",
    stroke: "currentColor",
    strokeWidth: 1.23,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M4.92578 5.52148L23.8824 24.4781",
    stroke: "currentColor",
    strokeWidth: 1.23,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M14.4043 28.4042C21.8072 28.4042 27.8085 22.4029 27.8085 15C27.8085 7.59699 21.8072 1.5957 14.4043 1.5957C7.00129 1.5957 1 7.59699 1 15C1 22.4029 7.00129 28.4042 14.4043 28.4042Z",
    stroke: "currentColor",
    strokeWidth: 1.23,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
};
export default SvgUnvertraeglichkeiten;